import request from './request';

const meals = {
	async getMeals(query) {
		const response = await request.get('/app/meals', query);
		return response;
	},
	async getMealCustomizations(query) {
		const response = await request.get('/app/meal-customizations', query);
		return response;
	}
};

export default meals;
